import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  OnInit
} from '@angular/core';

import { Cover } from '../../_data/projects';

@Component({ selector: 'app-card', templateUrl: './card.component.html', styleUrls: ['./card.component.scss'] })

export class CardComponent implements AfterViewInit, OnInit {
  card: any;
  container: any;
  back: any;
  front: any;
  shine: any;
  icon: any;

  @Input()
  public cover: Cover;
  background: string;

  mouseOver = false;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.card = this.elementRef.nativeElement.querySelector('.card');
    this.container = this.elementRef.nativeElement.querySelector('.container');
    this.back = this.elementRef.nativeElement.querySelector('.back');
    this.front = this.elementRef.nativeElement.querySelector('.front');
    this.shine = this.elementRef.nativeElement.querySelector('.shine');
    this.icon = this.elementRef.nativeElement.querySelector('.icon');

    this.background = this.cover && this.cover.background ?
      this.cover.background : 'radial-gradient(farthest-side at 50% 50%, rgba(0,0,0,0) 48%, rgba(0,0,0,.1) 150%)';
  }

  ngAfterViewInit() {
    this.card.addEventListener('mousemove', (e) => {
      this.processMovement(e);
    });
    this.card.addEventListener('mouseenter', () => {
      this.processEnter();
    });
    this.card.addEventListener('mouseleave', () => {
      this.processExit();
    });
  }

  processMovement(e) {
    const card = this.card,
    bd = document.getElementsByTagName('body')[0],
    htm = document.getElementsByTagName('html')[0],
    icon = this.icon,
    shine = this.shine,
    back = this.back,
    front = this.front,
    container = this.container,
    bdst = bd.scrollTop || htm.scrollTop,
    bdsl = bd.scrollLeft,
    pageX = e.pageX,
    pageY = e.pageY,
    offsets = card.getBoundingClientRect(),
    w = card.clientWidth || card.offsetWidth || card.scrollWidth, // width
    h = card.clientHeight || card.offsetHeight || card.scrollHeight, // height
    wMultiple = 320 / w,
    offsetX = 0.52 - (pageX - offsets.left - bdsl) / w, // cursor position X
    offsetY = 0.52 - (pageY - offsets.top - bdst) / h, // cursor position Y
    dy = (pageY - offsets.top - bdst) - h / 2, // @h/2 = center of container
    dx = (pageX - offsets.left - bdsl) - w / 2, // @w/2 = center of container
    yRotate = (offsetX - dx) * (0.035 * wMultiple), // rotation for container Y
    xRotate = (dy - offsetY) * (0.05 * wMultiple), // rotation for container X
    arad = Math.atan2(dy, dx); // angle between cursor and center of container in RAD


    let angle = arad * 180 / Math.PI - 90, // convert rad in degrees
    imgCSS = 'rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg)'; // img transform

    // get angle between 0-360
    if (angle < 0) {
      angle = angle + 360;
    }

    // container transform
    if (this.mouseOver) {}
    {
      imgCSS += ' scale3d(1.04,1.04,1.04)';
    }
    container.style.transform = imgCSS;
    icon.style.transform = imgCSS;

    // gradient angle and opacity for shine
    const shineGradient =
      'linear-gradient(' + angle + 'deg, rgba(255,255,255,' + (pageY - offsets.top - bdst) / h * 0.4 + ') 0%,rgba(255,255,255,0) 80%)';

    shine.style
      .background = shineGradient;

    const getOffsetX = (offsetX * 2) - 0.1;
    const getOffsetY = (offsetY * 2) - 0.1;

    shine.style.transform = 'translateX(' + getOffsetX + 'px) translateY(' + getOffsetY + 'px)';

    // parallax for each layer
    const layers = [
      back, front
    ];
    if (icon) {
      layers.push(icon);
    }
    const totalLayers = layers.length;
    let revNum = totalLayers;
    for (let ly = 0; ly < totalLayers; ly++) {
      layers[ly].style.transform =
        'translateX(' + (offsetX * revNum) * ((ly * 1.5) / wMultiple) +
        'px) translateY(' + (offsetY * totalLayers) * ((ly * 1.5) / wMultiple) + 'px)';
      revNum--;
    }
  }

  processEnter() {
    this.mouseOver = true;
  }

  processExit() {
    this.mouseOver = false;

    this.container.style.transform = '';
    this.shine.style.cssText = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/_common/card/card.component.ts